import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';
import { Input } from 'Components/Input';
import Select from 'Components/Select';

export default ({
  requestInProcess,
  id,
  type,
  submissionDate,
  isUserCanEdit,
  description,
  componentTypeFieldValues,
  fieldsList,
  handleAdditionalInputChange,
  handleInputChange,
  category,
  inputErrors,
}) => {
  function getEditableFields() {
    if (isUserCanEdit) {
      return componentTypeFieldValues.map((field, index) => {
        return showEditableField(field, index);
      });
    } else {
      return componentTypeFieldValues.map((field, index) => (
        <Text
          key={field.componentTypeFieldId}
          mainWrapperClassName={`text__wrapper_primary ${index % 2 === 0 ? '_margin_right_30' : ''}`}
          textClassName='text__text_primary'
          label={field.componentTypeFieldName}
          value={field.componentTypeFieldValue}
        />
      ));
    }
  }

  function showEditableField(field, index) {
    const fieldData = fieldsList.find(element => element.fieldName === field.componentTypeFieldName);

    if (fieldData.componentTypeFieldValues.length) {
      const defaultItem = fieldData.componentTypeFieldValues.find(
        element => element.value === field.componentTypeFieldValue
      );

      return (
        <Select
          key={field.componentTypeFieldId}
          type='primary'
          mainWrapperClassName={`${index % 2 === 0 ? '_margin_right_30' : ''}`}
          selectionList={fieldData.componentTypeFieldValues}
          defaultItem={defaultItem}
          itemNameIndicator='value'
          error={inputErrors[index]}
          label={`${field.componentTypeFieldName}${fieldData.required ? ' *' : ''}`}
          handleSelect={handleAdditionalInputChange(index)}
        />
      );
    } else {
      return (
        <Input
          mainWrapperClassName={`input__main-wrapper_primary ${index % 2 === 0 ? '_margin_right_30' : ''}`}
          inputClassName='input__input-field_primary'
          key={field.componentTypeFieldId}
          label={`${field.componentTypeFieldName}${fieldData.required ? ' *' : ''}`}
          value={field.componentTypeFieldValue}
          error={inputErrors[index]}
          onChange={handleAdditionalInputChange(index)}
        />
      );
    }
  }

  return (
    <section className='scene_section'>
      <header>General Information</header>
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Component ID'
        value={id}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _margin_right_30'
        textClassName='text__text_primary'
        label='Component Category'
        value={category.name}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Component Type'
        value={type.componentTypeName}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary  _width_pc_100'
        textClassName='text__text_primary'
        label='Submission Date'
        value={submissionDate && moment(submissionDate).format('MM / DD / YYYY')}
      />
      {getEditableFields()}
      <Input
        mainWrapperClassName='input__main-wrapper_primary _width_pc_100'
        inputClassName='input__input-field_primary'
        label='Component Description * (250 char. max)'
        value={description}
        onChange={handleInputChange('description')}
        error={inputErrors.description}
      />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/Edit/GeneralInformation.jsx